import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: "boxed-style settings-btn fluid-boxed-btn",
    id: "boxed-style",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleContainerStyleBtn && _ctx.toggleContainerStyleBtn(...args)))
  }, _cache[1] || (_cache[1] = [
    _createTextVNode(" Click To "),
    _createElementVNode("span", { class: "fluid" }, "Fluid", -1),
    _createElementVNode("span", { class: "boxed" }, "Boxed", -1)
  ])))
}